var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeartFilled = function SvgIconHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.887 3.443c2.361 0 4.264 1.968 4.92 2.952.655-.984 2.558-2.952 4.919-2.952 2.951 0 4.92 1.968 4.92 4.92 0 4.427-6.396 9.346-9.84 12.79-3.443-3.444-9.838-8.363-9.838-12.79 0-2.952 1.968-4.92 4.92-4.92Z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.738
  })));
};
export default SvgIconHeartFilled;